import React from 'react';

import classes from 'components/common/confirmChangesModal/confirmChangesModal.module.scss';

import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';

export const ConfirmChangesModal = ({
    showModal,
    onHideModal,
    handleCloseWithoutSave,
    handleSave,
    children,
    isLoading = false,
}) => {
    return (
        <Modal
            open={showModal}
            onClose={() => onHideModal()}
            actions={
                <>
                    <Button variant={'secondary'} onClick={() => onHideModal()}>
                        Cancel
                    </Button>

                    <Button variant={'secondary'} destructive={true} onClick={() => handleCloseWithoutSave()}>
                        No
                    </Button>

                    <Button variant={'primary'} onClick={() => handleSave()} disabled={isLoading}>
                        Yes
                    </Button>
                </>
            }
        >
            <div data-testid={'changes-modal-container'} className={classes.container}>
                {children}
            </div>
        </Modal>
    );
};
